import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

import { hasLandingPagesPermissions } from "@services/useLandingPagesPermissions";

// eslint-disable-next-line local-eslint-rules/enforce-namespace-modularity
import { isLandingPageSurveysEnabled } from "@scenes/MessageComposition/LandingPages/hooks/useLandingPageSurveysEnabled";

const LandingPage = lazy(() =>
  import("@scenes/MessageComposition/LandingPages/LandingPage").then((module) => ({
    default: module.LandingPage,
  }))
);

export const surveysHubLandingPagesDetailNRO: NavigationRoutingObject = {
  Component: LandingPage,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("surveys-sidebar-pill-menu-option", "Surveys"),
  pageNameForTracking: () => "Surveys Hub - Landing Page",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("surveys-sidebar-pill-menu-option-description", "View surveys across landing pages, campaigns, and Canvas"),
  icon: "nav-system-surveys",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    const { canReadLandingPages } = hasLandingPagesPermissions({ hasPermission });
    return (
      featureOn("surveys_hub_detail_page") &&
      featureOn("surveys_hub") &&
      isLandingPageSurveysEnabled(featureOn) &&
      canReadLandingPages
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  showInSearchResults: false,
  defaultRoute: "/engagement/surveys/:appGroupId",
};
